<div>
  @if (showTimeline && sessionName === 'Playback Mode') {
    <div>
      <app-playback-timeline [id]="playbackid"></app-playback-timeline>
    </div>
  }

  @if (showLiveTime && sessionName === 'Live Mode') {
    <div>
      <app-live-timeline [id]="liveid" class="livetimeBox"></app-live-timeline>
    </div>
  }

  @if (sessionName === 'Monitor Mode') {
    <div>
      <app-running-timeline (timelineClick)="onTimelineClick($event)"></app-running-timeline>
    </div>
  }
</div>
